module.exports = __webpack_public_path__ + "img/correo.162cefda.svg";